import React from 'react';
import { ListCheckIcon } from '@revfluence/fresh-icons/regular/esm';
import { Skeleton } from '@frontend/shadcn/components/ui/skeleton';
import { TWorklet } from '../../types';
import { StageToCreatorInteractionMap, TaskItem } from './TaskItem';

interface Props {
  stages?: TWorklet[];
  isLoading?: boolean;
}

export const TaskList: React.FC<Props> = ({ stages, isLoading }) => {
  const filteredStages = stages?.filter((stage) => !!StageToCreatorInteractionMap[stage?.specURI]) ?? [];

  return (
    <div className="rounded-2xl bg-white my-4 mx-6 p-3 shadow-sm">
      <div className="mb-3 flex items-center gap-2">
        <ListCheckIcon className="h-4 w-4 text-grey-6" />
        <h3 className="mb-0 text-sm font-medium text-grey-6">Tasks</h3>
      </div>
      {isLoading ? (
        <div className="flex flex-col gap-2">
          <Skeleton className="h-10 w-full" />
          <Skeleton className="h-10 w-full" />
          <Skeleton className="h-10 w-full" />
          <Skeleton className="h-10 w-full" />
        </div>
      ) : (
        <div className="flex flex-col gap-2">
          {filteredStages?.map((stage, index) => (
            <TaskItem key={stage.specKey} stage={stage} status={index === 0 ? 'active' : 'waiting'} />
          ))}
          {!filteredStages?.length && (
            <p className="text-center text-sm text-grey-4">
              No actionable tasks for creator
            </p>
          )}
        </div>
      )}
    </div>
  );
};
